import { useState, useEffect } from 'react';
import { X, TrendingUp, Award, Copy, CheckCircle } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

const TIER_COLOR = {
  A: 'from-yellow-500 to-yellow-600',
  B: 'from-slate-500 to-slate-600',
  C: 'from-orange-500 to-orange-600',
  D: 'from-red-500 to-red-600',
  E: 'from-gray-500 to-gray-600',
};

export default function NotificacaoUpgradeCredito({ notificacao, onClose }) {
  const [tempoRestante, setTempoRestante] = useState(60);
  const [copiado, setCopiado] = useState(false);
  const navigate = useNavigate();

  const d = notificacao.dados;

  useEffect(() => {
    const t = setInterval(() => {
      setTempoRestante(prev => {
        if (prev <= 1) { clearInterval(t); onClose(); return 0; }
        return prev - 1;
      });
    }, 1000);
    return () => clearInterval(t);
  }, [onClose]);

  function copiar() {
    if (!d.mensagem_whatsapp) return;
    navigator.clipboard.writeText(d.mensagem_whatsapp);
    setCopiado(true);
    setTimeout(() => setCopiado(false), 2000);
  }

  const gradiente = TIER_COLOR[d.tier] || TIER_COLOR.C;
  const limiteFormatado = d.novo_limite
    ? d.novo_limite.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
    : '—';
  const primeiroNome = (d.nome_cliente || '').split(' ')[0];

  return (
    <div className="w-96 bg-white rounded-xl shadow-2xl border-2 border-yellow-400 overflow-hidden animate-slide-in">
      {/* Header */}
      <div className={`bg-gradient-to-r ${gradiente} px-4 py-3 flex items-center justify-between`}>
        <div className="flex items-center gap-2">
          <div className="w-10 h-10 bg-white rounded-full flex items-center justify-center flex-shrink-0">
            <Award className="w-6 h-6 text-yellow-600" />
          </div>
          <div className="text-white">
            <h3 className="font-bold text-base leading-tight">Elegível para Upgrade!</h3>
            <p className="text-xs opacity-80">Crediário Rotativo</p>
          </div>
        </div>
        <button onClick={onClose} className="text-white hover:bg-white/20 rounded-lg p-1.5 transition-colors">
          <X className="w-5 h-5" />
        </button>
      </div>

      {/* Conteúdo */}
      <div className="p-4 space-y-3">
        {/* Cliente + Score */}
        <div className="bg-yellow-50 rounded-lg p-3 border border-yellow-200">
          <p className="font-bold text-gray-900 text-base">{d.nome_cliente}</p>
          <div className="flex items-center gap-3 mt-1.5">
            <span className="text-xs font-medium bg-yellow-100 text-yellow-800 px-2 py-0.5 rounded-full">
              {d.tier_label || 'Ouro'}
            </span>
            <span className="text-xs text-gray-500">Score <strong className="text-gray-800">{d.score}</strong>/1000</span>
          </div>
        </div>

        {/* Novo limite */}
        <div className="flex items-center justify-between bg-green-50 border border-green-200 rounded-lg p-3">
          <div>
            <p className="text-xs text-green-600 font-medium">Novo limite sugerido</p>
            <p className="text-xl font-bold text-green-700">{limiteFormatado}</p>
          </div>
          <TrendingUp className="w-8 h-8 text-green-400" />
        </div>

        {/* Ações */}
        <div className="flex gap-2">
          <button
            onClick={() => { navigate('/crediario-rotativo'); onClose(); }}
            className="flex-1 py-2 px-3 bg-blue-600 hover:bg-blue-700 text-white text-sm font-medium rounded-lg transition-colors"
          >
            Ver no painel
          </button>
          {d.mensagem_whatsapp && (
            <button
              onClick={copiar}
              className="flex items-center gap-1.5 py-2 px-3 border border-gray-300 hover:bg-gray-50 text-sm font-medium rounded-lg transition-colors"
              title="Copiar mensagem WhatsApp"
            >
              {copiado
                ? <CheckCircle size={14} className="text-green-500" />
                : <Copy size={14} className="text-gray-500" />}
              <span className="text-gray-700">{copiado ? 'Copiado!' : 'Copiar msg'}</span>
            </button>
          )}
        </div>

        {/* Barra de progresso */}
        <div className="w-full bg-gray-100 rounded-full h-1.5">
          <div
            className="bg-yellow-400 h-1.5 rounded-full transition-all duration-1000 ease-linear"
            style={{ width: `${(tempoRestante / 60) * 100}%` }}
          />
        </div>
        <p className="text-xs text-gray-400 text-center">Fechará em {tempoRestante}s</p>
      </div>
    </div>
  );
}
